import { idFlavor, N_Url, ORGANISATION_PERMISSIONS } from "../../common";
import * as z from "zod";
import { OrgMemberRole, OrgMemberStatus } from "../orgMember";

export interface N_OrganisationView {
  organisationId: idFlavor<"Organisation">;
  name: string;
  logo: N_Url;
  config: OrganisationConfig | null;
}

// Adding passthrough fields to the organisation config to allow new fields to be added without changing the DB table
export const organisationConfigZod = z
  .object({
    hideJobId: z.boolean(),
    allowedPublisherIdsForSearch: z.array(z.string()).optional(),
  })
  .passthrough();

// Explicitly define interface to avoid Zod internal type inference issues with passthrough
export interface OrganisationConfig {
  hideJobId: boolean;
  allowedPublisherIdsForSearch?: string[];
  [key: string]: unknown; // Allows passthrough fields
}

export interface BasicOrgAccessInfo {
  id: idFlavor<"Organisation">;
  name: string;
  logo: N_Url;
  config: OrganisationConfig | null;
  role: OrgMemberRole;
  status: OrgMemberStatus;
  permissions: ORGANISATION_PERMISSIONS[];
  orgMemberId: idFlavor<"OrganisationMember">;
  hidden: boolean;
}
